<template>
    <div :class="['slider',  {'noBtn':!closeBtn}]" >
        <button v-if="closeBtn" class="slider__close-btn" @click="$emit('close')"><i class="el-icon-circle-close"></i></button>
        <div ref="sliderContainer" class="slider__container" @touchend.stop ="mouseEnd" @touchmove="touchMove"  @touchstart="mouseStart">
            <div ref="sliderTrack" class="slider__track" :style="{ transform: `translateX(-${widthSlide*curentSlide}px)`}">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            slides: '',
            widthSlide:'',
            curentSlide:0,
            touchStart:0,
            touchEnd:0,
        }
    },
    props:{
        closeBtn:{
            type:Boolean,
            default: true,
        }
    },
    methods: {
        mouseStart(e){
            this.touchStart = e.touches[0].clientX
        },
        mouseEnd(e){
            if(this.touchStart<this.touchEnd){
                this.touchEnd - this.touchStart > 100 && this.touchEnd!==0 ? this.prev() : null
                
            }else if(this.touchStart>this.touchEnd){
                this.touchStart - this.touchEnd > 100 && this.touchEnd!==0  ? this.next() : null
            }
            
        },
        touchMove(e){
            this.touchEnd = e.touches[0].clientX
        },
        goToSlide(v){
            this.curentSlide = v
        },
        prev(){
            if(this.curentSlide>0){
                --this.curentSlide
                this.$emit('prev', this.curentSlide)
                this.touchStart = 0
                this.touchEnd = 0
            }
        },
        next(){
            if(this.curentSlide!==this.slides.length-1){
                ++this.curentSlide
                this.$emit('next', this.curentSlide)
                this.touchStart = 0
                this.touchEnd = 0
            }
        },
        setSlideWidth(){
            this.slides.forEach(el=>{
                el.style.width = this.widthSlide + 'px'
            })
        }
    },
    updated() {
        this.widthSlide = this.$refs.sliderContainer.clientWidth
        this.slides = [...this.$refs.sliderTrack.children]
        this.setSlideWidth()
    },
    mounted() {
        let sliderContainer = this.$refs.sliderContainer
        
        window.addEventListener('resize', ()=>{
            this.widthSlide = sliderContainer.clientWidth
        })
        this.widthSlide = this.$refs.sliderContainer.clientWidth
        this.slides = [...this.$refs.sliderTrack.children]
        setTimeout(()=>{
            this.widthSlide = this.$refs.sliderContainer.clientWidth
        },500)
    },
}
</script>

<style lang="scss">
    .slider{
        position: absolute;
        background-color: $basic-white;
        top: 0;
        left: 0;
        width: 100%;
        max-height: 100%;
        height: 100%;
        z-index: 19;
        overflow: hidden;
        display: grid;
        grid-template-rows: max-content 1fr;
        .slider__close-btn{
            padding: 10px;
            justify-self: end;
            i{
                color: $brand-clr-1;
                font-size: 32px;
            }
        }
        .slider__container{
            position: relative;
            height: 100%;
        }
        .slider__track{
            position: absolute;
            display: flex;
            height: 100%;
            transition-duration: 0.3s;
        }
        .slide{
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        
    }
    .noBtn{
        grid-template-rows: 1fr;
    }
</style>